export const dataHooks = {
  tooltip: 'status-indicator-tooltip', // StatusIndicator internal
  errorIcon: 'linear-progressbar-error-icon',
  successIcon: 'success-icon',
};

export const SKINS = {
  standard: 'standard',
  success: 'success',
  warning: 'warning',
  premium: 'premium',
  neutral: 'neutral',
};
